import { useEffect } from 'react'

import { ConversationApi } from 'conversations/api'
import { fetchInboxesAsync } from 'shared/store/actions/user'
import { Inbox } from 'shared/typings/bootstrap'
import useSWR from 'swr'

import { GlobalStore as store } from '@driftt/traffic-control'

const onlyEnabled = (inbox: Inbox): boolean => inbox.status === 'ENABLED'

const fetcher = (url: string) =>
  ConversationApi.get(url)
    .then((res) => res.data)
    .then((inboxes) => inboxes.filter(onlyEnabled))
const useInboxesSWR = () =>
  useSWR<Inbox[], Error>('/inboxes', fetcher, { revalidateOnFocus: false })

const EMPTY_ARRAY: Inbox[] = []
export const useEnabledInboxes = (): Inbox[] => {
  const { data, error } = useInboxesSWR()

  useEffect(() => {
    error && store.dispatch(fetchInboxesAsync.failure(error))
    data && store.dispatch(fetchInboxesAsync.success(data))
  }, [data, error])

  return data ?? EMPTY_ARRAY
}
